export default __webpack_public_path__ + "static/media/openCasket.6c9fd12e.png";